import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, brandSecondary, mention, mentionDark } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

const sidebarWidth = 390;
const interContainerMargin = 30;
const buttonHeight = 40;

export const styleSheet = StyleSheet.create({
	bodyField: {
		borderColor: mentionDark,
		borderRadius: 3,
		borderStyle: 'solid',
		borderWidth: 1,
		boxSizing: 'border-box',
		height: '100%',
		overflowX: 'hidden',
		overflowY: 'auto',
		width: `calc(100% - ${sidebarWidth}px)`,
	},
	bodyFieldSocial: {
		background: mention,
		height: `calc(100% - 40px)`,
		...CssSelectors.allChildren({
			height: 'auto',
			paddingTop: 40,
		}),
	},
	button: {
		height: buttonHeight,
		marginBottom: 20,
		marginLeft: interContainerMargin,
		width: `${sidebarWidth - 2 * interContainerMargin}px`,
	},
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		padding: '20px 20px 40px 20px',
	},
	containerSocial: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		padding: 0,
	},
	editor: {
		padding: '20px 30px',
	},
	header: {
		alignItems: 'flex-start',
		borderBottomColor: mentionDark,
		borderBottomStyle: 'solid',
		borderBottomWidth: 1,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		margin: 0,
		padding: '0 30px',
	},
	infoContainer: {
		backgroundColor: mention,
		borderColor: brandSecondary,
		borderRadius: 3,
		borderStyle: 'solid',
		borderWidth: 1,
		display: 'inline-block',
		fontStyle: 'italic',
		fontSize: 12,
		margin: '0 0 14px 0',
		maxHeight: 64,
		overflow: 'hidden',
		padding: '4px 10px',
		textOverflow: 'ellipsis',
		whiteSpace: 'pre-line',
	},
	mainContent: {
		display: 'flex',
		height: '100%',
	},
	name: {
		color: brandPrimaryText,
		fontSize: 24,
		margin: '10px 0 10px 0',
		maxWidth: '100%',
		minWidth: 380,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	previewContentBox: {
		background: 'white',
		borderRadius: 10,
		color: 'black',
		fontSize: 14,
		marginBottom: 20,
		marginTop: 12,
		opacity: 1,
		overflowWrap: 'break-word',
		transform: 'translate3d(0,0,0)',
		transition: 'opacity 0.2s, transform 0.5s',
		whiteSpace: 'pre-wrap',
		width: 372,
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
	sideBar: {
		boxSizing: 'border-box',
		height: '100%',
		marginLeft: interContainerMargin,
		width: sidebarWidth,
	},
	sideBarContent: {
		boxSizing: 'border-box',
		height: `calc(100% - ${buttonHeight + 60}px)`,
		marginTop: 10,
		padding: 20,
	},
});
